/* eslint-disable import/first */
import { lazy } from "react";
import MapIcon from "@material-ui/icons/Map";
import PublishIcon from "@material-ui/icons/Publish";
import PaletteIcon from "@mui/icons-material/Palette";
import AssessmentIcon from "@material-ui/icons/Assessment";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CollectionsIcon from "@material-ui/icons/Collections";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import PhotoSizeSelectActualIcon from "@material-ui/icons/PhotoSizeSelectActual";

const UploadLocation = lazy(() => import("views/uploadlocation"));
const ImageGallery = lazy(() => import("views/imagegallery"));
const MyAccount = lazy(() => import("views/account"));
const EditProfile = lazy(() => import("views/editprofile"));
const HowWork = lazy(() => import("views/howwork"));
const Policy = lazy(() => import("views/policy"));
const Terms = lazy(() => import("views/terms"));
const Privacy = lazy(() => import("views/privacy"));
const Help = lazy(() => import("views/help"));
const Feedback = lazy(() => import("views/feedback"));
const Marketing = lazy(() => import("views/marketing"));
const ViewStatistics = lazy(() => import("views/viewstatistics"));

export const BOSSFOTOS_INFO_SUBDOMAIN_BASE_URL = "https://info.bossfotos.com";

export const dashboardRoutes = [
  // {
  //     showable: false,
  //     galleryable: true,
  //     path: `/photographer/creategallery`,
  //     name: "Home",
  //     icon: AccountCircleIcon,
  //     component: ImageGallery,
  //     underline: true,
  // },
  {
    showable: false,
    galleryable: false,
    path: `/photographer/uploadlocation`,
    name: "UploadLocation",
    icon: MapIcon,
    component: UploadLocation,
  },
  // {
  //     path: '#',
  //     icon: null,
  //     showable: true,
  //     galleryable: true,
  //     name: "Load New Items",
  //     component: ImageGallery
  // },
  // {
  //     showable: true,
  //     galleryable: false,
  //     path: `/photographer/map/new`,
  //     name: "Create New Gallery",
  //     icon: EditIcon,
  //     component: ImageGallery,
  // },
  {
    showable: false,
    galleryable: false,
    path: `/photographer/photos`,
    name: "Load Photos",
    icon: CloudUploadIcon,
    component: ImageGallery,
  },
  {
    path: "#",
    icon: null,
    showable: true,
    galleryable: false,
    name: "View/Manage",
    component: ImageGallery,
  },
  {
    showable: false,
    galleryable: false,
    path: `/photographer/events`,
    name: "Events",
    icon: EmojiEventsIcon,
    component: ImageGallery,
  },
  {
    showable: true,
    galleryable: false,
    path: `/photographer/map`,
    name: "Galleries",
    icon: CollectionsIcon,
    component: ImageGallery,
  },
  {
    showable: true,
    galleryable: false,
    path: `/photographer/gallery/:id/view`,
    name: "Photos",
    icon: PhotoSizeSelectActualIcon,
    component: ImageGallery,
  },
  {
    showable: false,
    galleryable: false,
    name: "Photo Art",
    icon: PaletteIcon,
    path: "/photographer/photo_art_gallery",
    component: ImageGallery,
  },
  {
    showable: false,
    galleryable: false,
    path: `/photographer/pricing`,
    name: "Pricing",
    icon: MonetizationOnIcon,
    component: ImageGallery,
  },
  {
    path: "#",
    icon: null,
    name: "Sales",
    showable: true,
    galleryable: false,
    component: ImageGallery,
  },
  {
    showable: false,
    galleryable: false,
    path: `/photographer/sold`,
    name: "Photos Sold",
    icon: PublishIcon,
    component: ImageGallery,
  },
  {
    showable: true,
    galleryable: false,
    path: `/photographer/myaccount`,
    name: "Analysis",
    icon: AssessmentOutlinedIcon,
    component: MyAccount,
  },
  {
    showable: false,
    galleryable: false,
    path: `/photographer/analysis`,
    name: "Analysis",
    icon: AssessmentIcon,
    component: ImageGallery,
  },

  {
    showable: false,
    path: `/photographer/editdetails`,
    name: "Edit My Details",
    icon: AccountCircleIcon,
    component: EditProfile,
    underline: false,
  },
  // {
  //     showable: true,
  //     path: `/photographer/rule`,
  //     name: "Tips & Policies",
  //     icon: GavelIcon,
  //     component: Policy,
  //     underline: false,
  // },
  // {
  //     showable: true,
  //     path: `/photographer/toolbox`,
  //     name: "Marketing Tool Box",
  //     icon: BuildIcon,
  //     component: Marketing,
  //     underline: true,
  // },
  // {
  //     showable: true,
  //     path: `/photographer/statistics`,
  //     name: "View Statistics",
  //     icon: AssessmentIcon,
  //     component: ViewStatistics,
  //     underline: false,
  // },

  // {
  //     showable: true,
  //     path: `/photographer/feedback`,
  //     name: "Feedback",
  //     icon: FeedbackIcon,
  //     component: Feedback,
  //     underline: true,
  // },
  {
    showable: true,
    path: `/photographer/editdetails`,
    name: "Profile",
    icon: null,
    component: EditProfile,
    underline: false,
  },
  {
    showable: false,
    path: `/photographer/howitworks`,
    name: "How It Works",
    icon: null,
    component: HowWork,
    underline: false,
  },
  {
    showable: true,
    path: `${BOSSFOTOS_INFO_SUBDOMAIN_BASE_URL}/info-centre/?top-category=photographers`,
    name: "Help",
    icon: null,
    component: Help,
    underline: false,
    openLinkInNewBrowserTab: true,
  },
  {
    showable: true,
    path: `${BOSSFOTOS_INFO_SUBDOMAIN_BASE_URL}/privacy-policy`,
    name: "Privacy Policy",
    icon: null,
    component: Privacy,
    underline: false,
    openLinkInNewBrowserTab: true,
  },
  {
    showable: true,
    path: `${BOSSFOTOS_INFO_SUBDOMAIN_BASE_URL}/terms`,
    name: "Terms & Conditions",
    icon: null,
    component: Terms,
    underline: false,
    openLinkInNewBrowserTab: true,
  },
];
